import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PerfilEnum } from '../enums/perfil-enum';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'usuarios';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao`);
  }

  listarPerfisPorPerfilUsuario(perfil: PerfilEnum): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/perfisPorPerfilUsuario/${perfil as string}`);
  }

  alterarSenhaDoUsuario(entity: Object): Observable<Object> {
    return this.http.post(`${this.getBaseUrlPrivate()}/alterarSenha`, entity);
  }

  testeUsuarioLogado(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/testeUsuarioLogado`);
  }
}
